export function getHourList() {
	return Array(24).fill().map((_, hour) => hour);
}
export const HOUR_IN_MINUTES = 60;